<style src="./ItemDocuments.scss" lang="scss"></style>
<template>
  <section class="form-box item-documents">
    <h4 class="title">Buscar documento</h4>

    <form @submit.prevent="searchWithFilter" class="document-filter">
      <label class="field type">
        <select
          v-model="searchForm.documentTypeId"
          class="cp1-small-select selectfield"
        >
          <option :value="null">Tipo de arquivo</option>
          <option
            v-for="(documentType, documentTypeIdx) in documentTypeList"
            :key="documentTypeIdx"
            :value="documentType._id"
            >{{ documentType.title }}</option
          >
        </select>
      </label>
      <label class="field inputsearch">
        <input
          type="text"
          v-model="searchForm.description"
          placeholder="Descrição do arquivo"
          class="cp1-small-textbox"
        />
      </label>

      <div class="commands">
        <button class="cp1-small-button cp1-button__primary searchbutton">
          Buscar
        </button>
      </div>
    </form>

    <div class="emptylist" v-show="!documentList.length">
      <icon-empty class="emptyicon" />
      <p class="title">Ainda não há documentos</p>
    </div>

    <ul class="list" v-if="documentList.length > 0">
      <li
        v-for="(document, documentIdx) in documentList"
        :key="documentIdx"
        class="item"
      >
        <div class="column1">
          <div class="field">
            <span class="title">Tipo de documento</span>
            <span class="value">{{ document.documentTypes[0].title }}</span>
          </div>

          <div class="field">
            <span class="title">Descrição</span>
            <span class="descriptionvalue">{{ document.description }}</span>
          </div>
        </div>
        <div class="column2">
          <div class="filetype">
            <span class="title">Extensão</span>
            <span class="filevalue">{{ document.fileExtension }}</span>
          </div>

          <div class="filesize">
            <span class="title">Tamanho</span>
            <span class="filevalue">{{
              document.fileSize | humanFileSize
            }}</span>
          </div>

          <div class="filecreated">
            <span class="title">Criado em</span>
            <span class="filevalue">{{ document.createdAt | DateBR }}</span>
          </div>
        </div>
        <form
          @submit.prevent="
            viewDocument(documentIdx, document.documentId, document.fileType)
          "
          class="column3"
        >
          <button-submit
            class="viewbutton"
            :label="viewOrDownload(document.fileExtension)"
            :state="document.submitState"
          />
          <button
            type="button"
            class="btn btn-danger"
            @click="() => openRemoveModal(document)"
            :disabled="isRemoveButtonDisabled"
          >
            Excluir
          </button>
        </form>
      </li>
    </ul>

    <stored-navigator
      domain="EventDocuments"
      :totalPages="$store.getters['EventDocuments/TOTAL_PAGE']"
      :perPage="$store.getters['EventDocuments/PER_PAGE']"
      :actualPage="$store.getters['EventDocuments/ACTUAL_PAGE']"
      @refreshList="loadDocumentList"
    />

    <modal
      transition="nice-modal-fade"
      name="modalConfirmDeleteDocument"
      width="500px"
      height="auto"
      @before-close="enableRemoveButton"
    >
      <aside class="modal-confirm">
        <icon-danger class="illustration" />
        <p class="description">
          Excluir um documento é uma ação irreversível.
        </p>
        <p class="description typecode">
          digite o código <span class="code">{{ removeCode }}</span> no campo
          abaixo para confirmar sua decisão.
        </p>
        <form class="modal-removeform" @submit.prevent="confirmRemove">
          <input
            type="text"
            class="cp1-small-textbox"
            v-model="inputRemoveCode"
          />

          <div class="removeform">
            <button
              type="button"
              class="btn btn-ghost"
              @click="closeRemoveModal"
            >
              Cancelar
            </button>
            <button
              class="btn btn-danger"
              :disabled="isConfirmRemoveButtonDisabled"
            >
              Confirmar Exclusão
            </button>
          </div>
        </form>
      </aside>
    </modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import PDFObject from "pdfobject";
import { DateBR } from "@/components/primitives/helpers/filters";
import {
  ButtonSubmit,
  StoredNavigator,
  ButtonRemove
} from "@/components/primitives";
import { IconEmpty, IconDanger } from "@/components/primitives/icons";

export default {
  name: "ItemDocuments",
  components: {
    ButtonSubmit,
    ButtonRemove,
    StoredNavigator,
    IconEmpty,
    IconDanger
  },
  data: () => ({
    documentModal: false,
    searchForm: {
      documentTypeId: null,
      description: null
    },
    selectedDocumentToRemove: "",
    inputRemoveCode: "",
    removeCode: "",
    isConfirmRemoveButtonDisabled: false,
    isRemoveButtonDisabled: false
  }),
  filters: {
    DateBR,
    humanFileSize(size) {
      const i = Math.floor(Math.log(size) / Math.log(1024));
      return (
        (size / Math.pow(1024, i)).toFixed(2) * 1 +
        " " +
        ["B", "kB", "MB", "GB", "TB"][i]
      );
    }
  },
  computed: {
    ...mapGetters({
      documentTypeList: "DocumentType/LIST",
      documentList: "EventDocuments/DOCUMENT_LIST"
    })
  },
  mounted() {
    this.loadDocumentList();
  },
  beforeDestroy() {
    this.$store.commit("EventDocuments/RESET_STATE");
  },
  methods: {
    viewOrDownload(fileExtension) {
      return fileExtension === "pdf" ? "Visualizar" : "Download";
    },
    searchWithFilter() {
      this.$store.commit("EventDocuments/ACTUAL_PAGE", 0);
      this.$store.commit("EventDocuments/FORM_FILTER", this.searchForm);
      this.loadDocumentList();
    },
    async loadDocumentList() {
      const payload = {
        eventId: this.$route.params.id
      };

      try {
        await this.$store.dispatch("EventDocuments/LIST_BY_EVENT", payload);
      } catch (error) {
        this.$toasted.error("Não conseguimos carregar seus documentos");
      }
    },
    async viewDocument(documentIdx, documentId, fileType) {
      this.documentList[documentIdx].submitState = "WAIT";
      const payload = {
        eventId: this.$route.params.id,
        documentId,
        fileType
      };

      try {
        const data = await this.$store.dispatch(
          "EventDocuments/VIEW_DOCUMENT",
          payload
        );
        if (fileType === "application/pdf") {
          this.openAsPdf(data);
        } else {
          this.forceDownload(data);
        }
      } catch (error) {
        this.$toasted.error("Não conseguimos fazer o download desse arquivo");
      } finally {
        this.documentList[documentIdx].submitState = "REPOSE";
      }
    },
    openAsPdf({ data }) {
      try {
        this.$store.commit("EventDocuments/SHOW_PDF_DOCUMENT", true);
        this.$nextTick(() => {
          const rootPdfViewer = this.$root.$children[0].$refs.previewpdf;
          const options = {
            width: "90%"
          };
          PDFObject.embed(data, rootPdfViewer, options);
        });
      } catch (error) {
        return Error(error);
      }
    },
    forceDownload({ data, fileName }) {
      const bufferData = new Blob([new Uint8Array(data.data)]);
      const url = window.URL.createObjectURL(bufferData);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    },
    closeDocumentModal() {
      PDFObject.embed(null, this.$refs.previewpdf, { forcePDFJS: true });
      this.documentModal = false;
    },
    closeRemoveModal() {
      this.$modal.hide("modalConfirmDeleteDocument");
    },
    enableRemoveButton() {
      this.isConfirmRemoveButtonDisabled = false;
      this.isRemoveButtonDisabled = false;
    },
    openRemoveModal(document) {
      this.generateRemoveCode();
      this.isRemoveButtonDisabled = true;
      this.inputRemoveCode = "";
      this.documentInfo = { ...document };
      this.$modal.show("modalConfirmDeleteDocument");
    },
    async confirmRemove() {
      if (this.inputRemoveCode !== this.removeCode) {
        this.$toasted.error("Código de confirmação inválido");
        return;
      }

      const payload = {
        documentId: this.documentInfo.documentId
      };

      try {
        this.isConfirmRemoveButtonDisabled = true;
        await this.$store.dispatch(
          "EventDocuments/REMOVE_DOCUMENT_BY_ID",
          payload
        );
        this.$toasted.success("Documento excluído com sucesso");
        await this.loadDocumentList();
        this.closeRemoveModal();
      } catch (error) {
        this.$toasted.error("Não foi possível excluir o documento");
      } finally {
        this.isConfirmRemoveButtonDisabled = false;
        this.isRemoveButtonDisabled = false;
      }
    },
    generateRemoveCode() {
      const removeCode = Math.random().toString(9);
      const countRemoveCode = removeCode.length;
      this.removeCode = removeCode.slice(countRemoveCode - 4, countRemoveCode);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/event-documents/components/item-documents/ItemDocuments.vue